import { Injectable } from '@angular/core';
import { IApiBackendRouteService } from '../abstract/api-routes.service';
import { HttpClient } from '@angular/common/http';
import { API_BASE_URL } from '../../../core/providers/constants/api.constants';
import { Observable } from 'rxjs';
import { WorkOrderLotNumber } from '../types/lot-number';

@Injectable({
  providedIn: 'root',
})
export class ApiRouteLotNumberService extends IApiBackendRouteService {
  constructor(protected readonly http: HttpClient) {
    super();
  }
  urlRoute = `${API_BASE_URL}/lot-number`;

  lotNumber(workOrderId: number | string): Observable<WorkOrderLotNumber> {
    return this.http.get<WorkOrderLotNumber>(
      `${this.urlRoute}/by-work-order/${workOrderId}`
    );
  }

  bomLots(workOrderId: number | string): Observable<WorkOrderLotNumber> {
    return this.http.get<WorkOrderLotNumber>(
      `${this.urlRoute}/bom/by-work-order/${workOrderId}`
    );
  }

  validateBomLot(workOrderId: number, lotNumber: string): Observable<any> {
    return this.http.post(`${this.urlRoute}/bom/validate`, {
      workOrderId,
      lotNumber,
    });
  }
}
